<template>
  <div>
    <ValidationObserver ref="formValidator" class="w-100">
      <form class="needs-validation" validate>
        <div class="container-table-striped w-100">
          <div class="table-hover">
            <table class="table content-table-striped table-striped mb-5">
              <thead>
                <tr class="row global-thead-dark thead-property">
                  <th class="col-md-4">
                    <span class="d-flex">Modificaciones</span>
                  </th>
                  <th class="col-md-4">
                    <span class="d-flex">Comentarios</span>
                  </th>
                  <th class="col-md-4" />
                </tr>
              </thead>

              <tbody ref="container">
                <tr
                  v-for="(item, index) in modificationsList"
                  :key="index"
                  class="row"
                >
                  <td class="col-md-4 text-left">
                    <div>
                      <b class="ml-3">
                        <span>{{ item.codeDescription }}</span>
                      </b>
                    </div>
                  </td>

                  <td class="col-md-4 text-left">
                    <div class="ml-3">
                      <span>{{ item.description }}</span>
                    </div>
                  </td>
                  <td v-if="isDraft" class="col-md-4 text-right">
                    <button
                      class="btn btn-dropdown-actions dropdown-toggle pt-1"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Acciones
                    </button>
                    <div class="dropdown-menu pb-0">
                      <a class="drop-item" @click="removeHandler(item)">
                        <i class="fas fa-times-circle text-red pr-1" />
                        <span>Eliminar</span>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr v-if="isInsertMode" class="row">
                  <td class="col-md-4 text-left">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="SelectModificationType"
                      rules="required"
                    >
                      <CustomDropDown
                        v-model="serviceModification.modificationType"
                        placeholder="Seleccionar modificación..."
                        fieldkey="id"
                        required
                        fieldname="name"
                        :options="allModificationTypeList"
                        :error="errors[0]"
                        :custom-error-msg="errorMsgs['SelectModificationType']"
                      />
                    </ValidationProvider>
                  </td>
                  <td class="col-md-4 text-left">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Description"
                      rules="required"
                    >
                      <CustomInput
                        v-model="serviceModification.description"
                        placeholder="Escribir descripción..."
                        :error="errors[0]"
                        :custom-error-msg="errorMsgs['Description']"
                      />
                    </ValidationProvider>
                  </td>
                  <td class="col-md-4 text-right">
                    <div>
                      <ActionButton
                        class="btn btn-green success"
                        i="fas fa-save"
                        type="button"
                        @click="saveHandler()"
                      >
                        Guardar
                      </ActionButton>
                      <ActionButton
                        :class="'danger'"
                        i="fas fa-times-circle"
                        type="button"
                        @click="cancelHandler()"
                      >
                        Cancelar
                      </ActionButton>
                    </div>
                  </td>
                </tr>
              </tbody>

              <tfoot>
                <tr
                  v-if="
                    modificationsList.length == 0 &&
                      isInsertMode == false &&
                      isDraft
                  "
                  class="w-100 text-center"
                >
                  <button
                    id="btnFA"
                    class="btn bg-light-white w-50 pt-1 mt-3"
                    @click="addHandler()"
                  >
                    <i class="fas fa-file-plus pr-4 text-green" />
                    <span class="text-button-add-document">
                      Presionar aquí para añadir Modificaciones
                    </span>
                  </button>
                </tr>
                <tr v-else class="text-right">
                  <ActionButton
                    v-if="isDraft && !isInsertMode"
                    class="btn btn-green success float-right mr-2"
                    i="fas fa-file-plus pr-2"
                    type="button"
                    @click="addHandler()"
                  >
                    Añadir
                  </ActionButton>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import CustomInput from '@/components/common/CustomInput';
import ActionButton from '@/components/common/ActionButton';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomDropDown from '@/components/common/CustomDropDown';
import store from '@/store/index';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'ModificationsProgramStudent',
  mixins: [alert],
  components: {
    ActionButton,
    ValidationProvider,
    CustomDropDown,
    ValidationObserver,
    CustomInput,
  },
  data() {
    return {
      serviceModification: {
        modificationType: null,
        description: '',
      },
      allModificationTypeList: [],
      isInsertMode: false,
      peiId: store.state.peiSelected,
      errorMsgs: {
        SelectModificationType: 'Favor de hacer una selección. (6014)',
        Description: 'Explique brevemente su modificación. (6011)',
      },
    };
  },
  mounted() {
    this.fetchAllModificationTypes();
  },
  props: {
    modificationsList: {
      type: Array,
      required: true,
    },
    isDraft: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    addHandler() {
      const self = this;

      self.isInsertMode = true;
    },
    async saveHandler() {
      const self = this;

      const isValid = await self.$refs.formValidator.validate();

      if (isValid) {
        const params = {
          PeiId: self.peiId,
          PeiServiceModificationCodeId:
            self.serviceModification.modificationType.id,
          Description: self.serviceModification.description,
        };

        self
          .$ApiPost('api/pei/insertpeiservicemodification', params)
          .then(() => {
            self.$emit('refresh');
            self.cancelHandler();
          })
          .catch((e) => self.ShowToast('Error', e.message, null));
      }
    },
    cancelHandler() {
      const self = this;

      self.isInsertMode = false;
      self.serviceModification.modificationType = null;
      self.serviceModification.description = '';
    },
    async removeHandler(item) {
      const self = this;

      const question =
        '¿Está seguro que desea eliminar la modificación seleccionada?';
      const alertResponse = await self.ShowCancelModal(
        'Atención',
        question,
        'Sí',
        'No'
      );

      if (alertResponse) {
        self
          .$ApiPost('api/pei/deletepeiservicemodification', item)
          .then(() => {
            self.$emit('refresh');
          })
          .catch((e) => self.ShowToast('Error', e.message, null));
      }
    },
    fetchAllModificationTypes() {
      const self = this;

      self
        .$ApiGet('api/code/getpeicodeservicemodifications')
        .then((res) => {
          const data = res.data;

          if (data) {
            self.allModificationTypeList = data;
          }
        })
        .catch((e) => self.ShowToast('Error', e.message, null));
    },
  },
};
</script>

<style scoped src="@/assets/css/component/panel-simple.css"></style>
<style scoped>
.close-border {
  border: 1px solid #2db782;
  border-radius: 50px;
  display: inline-block;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.6em;
  text-align: center;
  width: 7.1875rem;
  height: 2.6875‬rem;
  cursor: pointer;
  color: #2db782;
}

.close-ico {
  color: #2db782;
  margin-right: 3px;
}

.fa-times-circle {
  font-size: 18px;
  vertical-align: top;
}

.fa-orange {
  color: #ff7058;
}

.badge-orange {
  background-color: #ff7058;
  border: 1px solid #ff7058;
}

.badge-disable {
  background-color: transparent;
  border: 1px solid #b5c3bc;
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.title-section {
  text-align: left;
  font: Bold 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.info-titule {
  margin-left: 17px;
  margin-top: -35px;
  margin-bottom: 20px;
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}

.custompadding {
  padding: 1.2rem 0rem 1.2rem 2rem !important;
}
.list-group-item.text-center {
  background: #fafbfa !important;
  padding: 1rem !important;
}
.readonly {
  width: 210px !important;
  height: 40px !important;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  padding-bottom: 0.5%;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
}

.dot {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px #00000029;
  padding-top: 7px;
}

.orange-icon {
  color: #ff7058;
  font-size: 15pt;
  padding-right: 4px;
  line-height: 23px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.alert-warning {
  background: #fff5e8 0% 0% no-repeat padding-box;
  border: 1px solid #fdac41;
  border-radius: 4px;
  opacity: 1;
}

.alert-icon {
  float: left;
  padding-top: 0.75%;
}

.alert-content {
  margin-left: 1.5%;
}

.alert span {
  text-align: left;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  color: #af6708;
  display: inline-grid;
}
.panel-simple .header > div > span {
  font-weight: 400 !important;
}

.btn-success-outline {
  height: 38px;
  border: 1px solid #2db782 !important;
  color: #2db782;
}

.btn-success-outline:hover {
  background: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
  cursor: pointer;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
</style>
